import { get } from 'svelte/store';
import { api_url_dev, api_url_prod, backend_url, storeLoader } from './store';
/**
 * isElementInViewport
 * @param el
 * @returns
 */
export function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}
/**
 * Initialisation de l'URL du backend
 */
export function setBackendUrl() {
    const base_url = window.location.origin; // URL du frontend
    const indiceLocalhost = base_url.indexOf("/127.0.0.1");
    if (indiceLocalhost > 0) {
        backend_url.set(get(api_url_dev));
    }
    else {
        backend_url.set(get(api_url_prod));
    }
}
/**
 * Mise à jour d'un cookie
 * @param name
 * @param value
 * @param hours
 */
export function setCookie(name, value, hours) {
    var expires = "";
    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
/**
 * Récupération de la valeur d'un cookie
 * @param name
 * @returns
 */
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
/**
 * Suppression d'un cookie
 * @param name
 */
export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
/**
 * launchLoader
 * @param tempo by default 10 seconds
 */
export function launchLoader(tempo = 10000) {
    storeLoader.set(true);
    setTimeout(function () { storeLoader.set(false); }, tempo);
}
/**
 * stopLoader
 */
export function stopLoader() {
    storeLoader.set(false);
}
